import React from 'react';
import {Link} from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import '../common/sortable-list.css';
import './booth-list.css';

/** @class BoothList
  * A component which lists booths available to edit.
  */
export default class BoothList extends ReactFireComponent {
  /** @constructor
    * Constructs a new BoothList instance
    */
  constructor(props) {
    super(props);
    this.state = {booths:[]}
    this.dataURL = `/expos/${this.props.expoID}/booths`;
    this.hallURL = `/expos/${this.props.expoID}/halls`;
    this.firebaseRef = firebase.database().ref(this.dataURL);
    this.handleNewBooth = this.handleNewBooth.bind(this);
    this.togglePublished = this.togglePublished.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding data
    * in the Firebase realtime database.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'booths');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the Firebase database.
    */
  componentWillUnmount() {
    this.unbind();
  }
  /** @function handleNewBooth
    * Creates a new booth.
    */
  handleNewBooth(){
    const newBooth = {
      metadata: {
        name: "New Booth",
        published: false
      },
      halls: {},
      contents: {}
    };
    this.firebaseRef.push(newBooth);
  }
  /** @function handleRemove
    * Deletes the specified booth from the booth list,
    * any halls it belongs to, and any media uploaded
    * to firebase storage
    * @param {Object} booth - the booth to remove
    */
  handleRemove(booth){
    if(window.confirm("Are you sure? This will permanently remove the booth")) {
      var updates = {
        // remove the booth
        [`${this.dataURL}/${booth.id}`]: null
      }
      Object.keys(booth.halls || {}).forEach(hallID => {
        // remove the hall entry for the booth
        updates[`${this.hallURL}/${hallID}/booths/${booth.id}`] = null;
      });
      firebase.database().ref().update(updates);
      firebase.storage().ref().child(`${this.dataURL}/${booth.id}`)
      .delete().catch(err => {
        console.error(err);
      });
    }
  }
  /** @function togglePublished
    * Toggles the published status of the specified booth.
    * @param {integer} index - the index of the booth in the booth list
    */
  togglePublished(index){
    var booth = this.state.booths[index];
    this.firebaseRef.child(booth.id).child('metadata')
    .child('published').set(!booth.metadata.published);
  }
  /** @function render
    * Renders the component.
    */
  render() {
    const booths = this.state.booths.sort((a,b)=>{
      return String.prototype.localeCompare.call(a.metadata.name, b.metadata.name);
    }).map((booth, index) => (
      <div key={index} className="sortable-list-item" style={{width: 'calc(100vw - 2rem)'}}>
        {booth.metadata.name}
        <span>
          <a href={`https://editor.vexposhows.com/preview/#${this.dataURL}/${booth.id}`} target="blank">
            <FontAwesome name="eye"/>
            Preview Link
          </a>
          <FontAwesome name={booth.metadata.published?'flag':'flag-o'}
            style={{color:"#4eba6f", cursor: "pointer"}}
            onClick={() => this.togglePublished(index)}
            />
          <Link to={`${this.dataURL}/${booth.id}`}>
            <FontAwesome name="edit"
              style={{color:"#965ba5", cursor:"pointer"}}/>
          </Link>
          <FontAwesome name="times"
            style={{color: "red", cursor: "pointer"}}
            onClick={() => {
              if(window.confirm("Are you sure?  This will permanently delete the booth")){
                this.handleRemove(booth);
              }
            }}/>
        </span>
      </div>
    ))
    return (
      <div>
        <label>Booths</label>
        <div className="sortable-list">
          {booths}
        </div>
        <button onClick={this.handleNewBooth}>
          <FontAwesome name="plus"/>
          Add New Booth
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-list/booth-list.js